import React, { createContext, ReactNode, useContext } from 'react';

export type TreatmentEvents = {
  onTreatmentPublished: () => void;
  onDraftAction: () => void;
};

type FileEntryViewerTreatmentContextType = {
  treatmentEvents: TreatmentEvents;
  isAutomationEnabled?: boolean;
};

const FileEntryViewerTreatmentContext = createContext<
  FileEntryViewerTreatmentContextType | undefined
>(undefined);

type FileEntryViewerTreatmentProviderProps = {
  treatmentEvents: TreatmentEvents;
  isAutomationEnabled?: boolean;
  children: ReactNode;
};

export const FileEntryViewerTreatmentProvider = ({
  treatmentEvents,
  children,
  isAutomationEnabled = true,
}: FileEntryViewerTreatmentProviderProps) => {
  return (
    <FileEntryViewerTreatmentContext.Provider value={{ treatmentEvents, isAutomationEnabled }}>
      {children}
    </FileEntryViewerTreatmentContext.Provider>
  );
};

export function useFileEntryViewerTreatment() {
  const store = useContext(FileEntryViewerTreatmentContext);
  if (!store) {
    throw new Error(
      'useFileEntryViewerTreatment must be used within a FileEntryViewerTreatmentProvider'
    );
  }
  return store;
}
